// extracted by mini-css-extract-plugin
export default {"sectionContainer":"ServiceGridSection_sectionContainer__zuL3S","header":"ServiceGridSection_header__It7KS","grid":"ServiceGridSection_grid__0A3C0"};